import slugify from 'slugify';

export const getSlug = (inputString: string) => slugify(inputString, { lower: true });
